import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Observable } from "rxjs/Observable";

import {
  NgbModal,
  NgbModalRef,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  mergeMap,
} from "rxjs/operators";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { GenericCheckBoxStatus } from "../../../common/generic-check-box-with-minus/generic-checkbox-with-minus.component";
import {
  ChildDiscountModel,
  ChildDiscountStatus,
} from "../discount-models/ChildDiscountModel";
import {
  baseChildDiscountMocks,
  mockAddChildrenEventStatusFromPricing,
} from "../mock/baseChildDiscount.mock";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { fromPromise } from "rxjs/observable/fromPromise";
import { DiscountManagementService } from "../../../_services/discount-management.service";

@Component({
  selector: "new-discount-form-select-children",
  templateUrl: "./new-discount-form-select-children.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "./new-discount-form-select-children.component.scss",
  ],
})
export class NewDiscountFormSelectChildrenComponent
  implements AfterViewInit, OnInit
{
  @Input("newDiscountFormState")
  public newDiscountFormState$: Observable<NewDiscountFormState>;
  public allAvailableChildren: ChildDiscountModel[] = baseChildDiscountMocks;
  @Input("customStyle") public customStyle: "" | "thinner" = "";
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<NewDiscountFormState> = new EventEmitter<NewDiscountFormState>();
  @ViewChild("resultTemplate") public resultTemplate;
  public autoCompleteInput: ElementRef;
  public searchForm: FormGroup;
  public searchFieldName: string = "searchField";
  public translations$: Observable<ITranslations>;
  public selectionStatus: GenericCheckBoxStatus =
    GenericCheckBoxStatus.AllSelected;
  public readonly ChildDiscountStatus = ChildDiscountStatus;
  @ViewChild("autoCompleteInput")
  private currentFormState: NewDiscountFormState;

  constructor(
    private modalService: NgbModal,
    protected translationService: TranslationService,
    protected discountManagementService: DiscountManagementService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.searchForm = new FormGroup({});
    this.searchForm.addControl(this.searchFieldName, new FormControl(""));
    this.newDiscountFormState$.subscribe((state) => {
      this.currentFormState = state;
    });
  }

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) => {
    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.discountManagementService.searchPChildForNewSubsidyByText({
            childEvents: this.currentFormState.event.childEvents.filter(
              (c) => c.isSelected
            ),
            searchText: term,
          })
        );
      })
    );
  };

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public submit() {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public childSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    this.searchForm.controls[this.searchFieldName].reset(null);
    const childSelectionCallback = () => {
      let childToAdd = $event.item as ChildDiscountModel;
      if (this.currentFormState.children.some((c) => c.id === childToAdd.id)) {
        return;
      }

      const newFormState = { ...this.currentFormState };
      newFormState.children = [...newFormState.children, childToAdd];
      this.updateDiscountEvent.emit({
        ...newFormState,
      });
    };

    if (this.currentFormState.amount) {
      const warningMessage =
        "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
      this.modalNotification(warningMessage, childSelectionCallback);
      return;
    } else {
      childSelectionCallback();
    }
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public removeChildHandler(discountChild: ChildDiscountModel) {
    if (this.currentFormState.amount) {
      const warningMessage =
        "הפעולה תאפס את טופס הסבסוד וכל הנתונים שהוזנו. האם להמשיך?";
      this.modalNotification(warningMessage, () => {
        this.removeDiscountChild(discountChild);
      });
      return;
    } else {
      this.removeDiscountChild(discountChild);
    }
  }

  public additionalChildData(r: ChildDiscountModel): string {
    if (r.childStatus === ChildDiscountStatus.AlreadyHasDiscount) {
      return "קיים כבר סבסוד לארוע זה";
    } else if (r.childStatus === ChildDiscountStatus.HasSomeDiscounts) {
      return "קיים סבסוד לחלק מהתמחורים";
    }
    return "";
  }

  protected modalNotification(message: string, callOnApprove?: () => void) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      cancelOption: "ביטול",
      modalHeader: "איפוס הטופס",
      modalText,
      onlyApprove: false,
    };
    modalRef.result.then((res) => {
      if (res === "approve" && callOnApprove) {
        callOnApprove();
      }
    });
  }

  private removeDiscountChild(discountChild: ChildDiscountModel) {
    const newState = {
      ...this.currentFormState,
      amount: null,
      discountDetails: null,
    };
    newState.children = newState.children.filter(
      (c) => c.id !== discountChild.id
    );
    this.updateDiscountEvent.emit(newState);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-select-children/new-discount-form-select-children.component.ts